import CheckUserAccess from './CheckUserAccess';

export default CheckUserAccess;
